export default __webpack_public_path__ + "static/media/google_maps.87437975.svg";